import React, { useRef, useState } from 'react';
import { AiraTooltip } from './AiraTooltip';
import { AiraRound } from './Icons';
import Popup from './Popup';
import { rootClsPrefix as clsPrefix } from '../constants';
import { getAnchoredPopupPosition, getBottomRightPopupPosition } from '../util';
import classNames from 'classnames';
import { Tooltip } from './Tooltip';

const AiraContainer = ({
  titlePadding,
  popupWidth,
  title,
  titleDescription,
  children,
  Icon = AiraRound,
  iconProps = {},
  iconSize = '1.9rem',
  iconPlacement = null,
  popupPlacement = { type: 'float-br', padding: '1.25rem' },
  onShow = () => {},
  onHide = () => {},
  titleBarIcon,
  rootStyle = {},
  popupHeight,
}) => {
  const rootRef = useRef();
  const [visible, setVisible] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  if (iconPlacement === 'float-br') {
    rootStyle = { bottom: '0.2rem', right: '0.2rem', ...rootStyle };
  }
  let defaultPopupPosition = () => {
    return { left: '0', top: '0' };
  };
  if (popupPlacement.type === 'float-br') {
    defaultPopupPosition = (popupWidth, popupHeight) => {
      return getBottomRightPopupPosition(
        popupWidth,
        popupHeight,
        popupPlacement.padding,
      );
    };
  }
  if (popupPlacement.type === 'anchor-br') {
    defaultPopupPosition = (popupWidth, popupHeight) =>
      getAnchoredPopupPosition(rootRef, titlePadding, popupWidth, popupHeight);
  }

  const onIconClick = () => {
    setTooltipVisible(false);
    setVisible(true);
    onShow();
  };

  const combinedClasses = classNames(
    `${clsPrefix}-root`,
    { [`${clsPrefix}-float-br`]: iconPlacement === 'float-br' },
    { [`${clsPrefix}-fixed-br-beamer`]: iconPlacement === 'fixed-br-beamer' },
  );

  return (
    <div ref={rootRef} style={rootStyle} className={combinedClasses}>
      <Tooltip
        placement="left"
        title={<AiraTooltip title={title} description={titleDescription} />}
        visible={tooltipVisible}
        onVisibleChange={visible => {
          setTooltipVisible(visible);
        }}
      >
        <div style={{ display: 'inline-block' }}>
          <Icon
            aria-label="open-aira"
            onClick={onIconClick}
            data-visible={visible}
            className={`${clsPrefix}-bot-icon`}
            iconSize={iconSize}
            {...iconProps}
          />
        </div>
      </Tooltip>
      <Popup
        onHide={onHide}
        visible={visible}
        setVisible={setVisible}
        popupWidth={popupWidth}
        defaultPopupPosition={defaultPopupPosition}
        titlePadding={titlePadding}
        title={title}
        titleDescription={titleDescription}
        iconSize={iconSize}
        titleBarIcon={titleBarIcon || Icon}
        popupHeight={popupHeight}
        popupPlacement={popupPlacement}
      >
        {children}
      </Popup>
    </div>
  );
};

export default AiraContainer;
